/**
 * FotoModelo - Componente de foto do modelo/embarcação
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ImageIcon } from 'lucide-react';
import ImageUpload from '../ImageUpload';
import { processImageUrl } from '../../utils/imageConverter';

const FotoModelo = ({ 
  fotoModelo, 
  setFotoModelo, 
  vesselModel, 
  embarcacao,
  setHasChanges 
}) => {
  const handleFotoChange = (url) => {
    setFotoModelo(url);
    setHasChanges(true);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <ImageIcon className="h-4 w-4" />
          Foto do Modelo / Barco
        </CardTitle>
      </CardHeader>
      <CardContent>
        {fotoModelo ? (
          <div className="space-y-3">
            <div className="aspect-video relative rounded-lg overflow-hidden border bg-gray-100">
              <img
                src={processImageUrl(fotoModelo)}
                alt="Foto do modelo"
                className="w-full h-full object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div 
                className="absolute inset-0 hidden items-center justify-center bg-gray-100 text-gray-400"
              >
                <ImageIcon className="h-12 w-12" />
              </div>
            </div>
            <ImageUpload
              value={fotoModelo}
              onChange={handleFotoChange}
              label="Alterar foto"
            />
          </div>
        ) : (
          <div className="border-2 border-dashed rounded-lg p-6 text-center bg-gray-50">
            <ImageIcon className="h-10 w-10 mx-auto text-gray-300 mb-3" />
            <p className="text-sm text-gray-500 mb-3">
              Nenhuma foto adicionada
            </p>
            <ImageUpload
              value=""
              onChange={handleFotoChange}
              label="Adicionar foto"
            />
          </div>
        )}
        
        {vesselModel?.imagem_referencia && !fotoModelo && (
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-xs text-blue-600 mb-2">
              Imagem de referência do modelo:
            </p>
            <img
              src={processImageUrl(vesselModel.imagem_referencia)}
              alt="Referência"
              className="w-full rounded border"
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default FotoModelo;
